<template>
  <section class="container content-section">
    <h2>
      <contentful-text
        :item="contentfulText('pictureday-homepage-2023-v01-clients-title')"
        :render-inline="true"
      />
    </h2>
    <div class="row">
      <div class="col-xs-12 col-md-8 col-md-offset-2">
        <contentful-text
          :item="contentfulText('pictureday-homepage-2023-v01-clients-body')"
          :apply-markdown="true"
          class="content-section__text"
        />
      </div>
    </div>
    <div
      v-if="isTabletOrHigher"
      class="row"
    >
      <div
        v-for="featuredClient in featuredClients"
        :key="featuredClient.Id"
        class="col-xs-6 col-sm-4 col-md-2 clients__client-column"
      >
        <featured-client :client="featuredClient" />
      </div>
    </div>
    <div v-if="isMobile">
      <client-carousel :clients="featuredClients" />
    </div>
  </section>
</template>

<script>
import ClientCarousel from '../ContentItems/GradClientCarousel.vue'
import FeaturedClient from '../ContentItems/FeaturedClient.vue'

import ResponsiveBreakpointMixin from '@Shared/mixins/responsive-breakpoints'

export default {
  name: 'ClientsListing',
  components: {
    ClientCarousel,
    FeaturedClient
  },
  mixins: [ ResponsiveBreakpointMixin ],
  computed: {
    content () {
      return this.$store.state.pageContent
    },
    featuredClients () {
      return this.$store.getters.featuredClientsSorted
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: $font-barlow-condensed;
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1.875rem;
  text-transform: uppercase;
  margin-bottom: 2rem;
  text-align: center;

  @media screen and (min-width: $screen-sm-min) {
    font-size: 3.375rem;
    line-height: 3.375rem;
  }
}

.content-section {
  &__text {
    & /deep/ p {
      color: #525252;
      font-family: $font-circular-std;
      font-size: 1.2rem;
      padding: 0;
      text-align: center;

      @media screen and (min-width: $screen-md-min) {
        font-size: 1.375rem;
        padding: 0 2rem;
      }
    }
  }
}

.clients {
  &__client-column {
    margin: 0;
    padding: 0.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/index/components/ContentSections/Clients.vue